import { useCallback } from 'react';
import { useSettingsStore } from '@/stores/settingsStore';
import { translate, type I18nKey, type Lang } from './translations';

/**
 * Translation hook. Subscribes to the active language so every consumer
 * re-renders when the user switches via the Settings screen.
 *
 *   const t = useT();
 *   <button>{t('common.cancel')}</button>
 *   <span>{t('match.auto_continue', { secs: 14 })}</span>
 */
export function useT(): (key: I18nKey, vars?: Record<string, string | number>) => string {
  const lang = useSettingsStore((s) => s.lang);
  return useCallback(
    (key, vars) => translate(lang, key, vars),
    [lang],
  );
}

/** Read-only access to the current lang code (for switch statements etc.). */
export function useLang(): Lang {
  return useSettingsStore((s) => s.lang);
}
